// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4p-1";
export var standaloneTable = "_4p-0";